// components/PageViewTracker.tsx
'use client'; // Ensure this component is treated as a Client Component

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const PageViewTracker = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = `${pathname}?${searchParams}`;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: url,
    });
  }, [pathname, searchParams]);

  return null;
};
